import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'

export class BolsaFamilia {
  importar(formData: FormData, config: AxiosRequestConfig): AxiosPromise<void> {
    return axios.post(`/api/bolsa-familia/importar`, formData, config)
  }
}
